module.exports = __webpack_public_path__ + "img/89.1.6a830471.jpg";